export default function PHP_Cookies() {
  return (
    <div>
      <h1>PHP_Cookies</h1>
    </div>
  );
}
